const findMinMaxAlumSwing = (
  equal: boolean,
  sideLites: string,
  swingType: string,
  thickFrame: boolean
) => {
  if (!swingType) return { min: 0, max: 0 };

  let limits = {};

  if (thickFrame) {
    limits = {
      "Single Swing": {
        none: { min: 26.3125, max: 50.3125 },
        "Add Single Sidelite": { min: 51.84375, max: 99.84375 },
        "Add Double Sidelite": { min: 77.375, max: 149.375 },
      },
      "Pair Swing": {
        none: { min: 50.5625, max: 98.5625 },
        "Add Single Sidelite": { min: 76.09375, max: 148.09375 },
        "Add Double Sidelite": { min: 101.625, max: 197.625 },
      },
    };
  } else {
    limits = {
      "Single Swing": {
        none: { min: 25.5625, max: 49.5625 },
        "Add Single Sidelite": { min: 51.09375, max: 99.09375 },
        "Add Double Sidelite": { min: 76.625, max: 148.625 },
      },
      "Pair Swing": {
        none: { min: 49.8125, max: 97.8125 },
        "Add Single Sidelite": { min: 75.34375, max: 147.34375 },
        "Add Double Sidelite": { min: 100.875, max: 196.875 },
      },
    };
  }

  return {
    min: limits[swingType][sideLites]["min"],
    max: limits[swingType][sideLites]["max"],
  };
};

export default findMinMaxAlumSwing;
